<template>
  <footer class="site-footer">
    <div class="footer-inner">
      <nav class="footer-nav">
        <a :href="links.gapGlobal" target="_blank" rel="noopener">GAP GLOBAL</a>
        <span class="sep">/</span>
        <a :href="links.gapLib" target="_blank" rel="noopener">GAP LIB</a>
        <span class="sep">/</span>
        <a :href="links.eLearning" target="_blank" rel="noopener">E-LEARNING</a>
        <span class="sep">/</span>
        <a :href="links.contactUs" target="_blank" rel="noopener">CONTACT US</a>
        <span class="sep">/</span>
        <a :href="links.events" target="_blank" rel="noopener">EVENTS</a>
        <span class="sep">/</span>
        <a :href="links.car" target="_blank" rel="noopener">COURSE ATTENDANCE REGISTRATION (CAR)</a>
      </nav>
      <p class="copyright">Copyright © {{ year }}. All Rights Reserved by Gap Management Institute.</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
  props: {
    links: {
      type: Object,
      default: () => ({
        gapGlobal: 'https://gapmanagementinstitute.org/',
        gapLib: 'https://gaplib.gapmanagementinstitute.org/#/library',
        eLearning: 'https://elearning.gapmanagementinstitute.org/',
        contactUs: 'https://gapmanagementinstitute.org/contact',
        events: 'https://gapmanagementinstitute.org/events',
        car: '#',
      })
    }
  },
  computed: {
    year() { return new Date().getFullYear() }
  }
}
</script>

<style scoped>
.site-footer {
  background-color: #212021;
  color: #e5e5e5;
  width: 100%;
}
.site-footer a { color: #e5e5e5; }

.footer-inner {
  max-width: 1280px;
  margin: 0 auto;
  padding: 16px 20px;
  text-align: center;
}

.footer-nav {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
}

.footer-nav a {
  text-decoration: none;
  padding: 4px 2px;
}
.footer-nav a:hover { text-decoration: underline; color: #ffffff; }
.footer-nav .sep { opacity: 0.5; }

.copyright { font-size: 13px; opacity: 0.85; margin: 0; }
</style>
